export default __webpack_public_path__ + "static/media/i165jp.07c0adc3.webp";